
import { defineComponent } from "vue-demi";

export default defineComponent({
  name: "Notification",
  props: {
    title: {
      type: String,
      default: "",
    },
    description: {
      type: String,
      default: "",
    },
    actionOk: {
      type: String,
      default: "",
    },
    actionCancel: {
      type: String,
      default: "",
    },
    info: {
      type: String,
      default: "",
    },
  },
  emits: ["ok", "cancel"],
  setup(props, { emit }) {
    function onOk() {
      emit("ok");
    }

    function onCancel() {
      emit("cancel");
    }

    return {
      onOk,
      onCancel,
    };
  },
});
